module.exports = __webpack_public_path__ + "fonts/SUIT-Light.3f3d0d47.woff2";